package com.mgacreative.hotel.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.domain.model.Agency
import com.mgacreative.hotel.domain.model.AgencyAllotment
import com.mgacreative.hotel.domain.repository.AgencyRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AdminAgencyViewModel(
    private val agencyRepository: AgencyRepository
) : ViewModel() {

    private val _agencies = MutableStateFlow<List<Agency>>(emptyList())
    val agencies: StateFlow<List<Agency>> = _agencies.asStateFlow()

    private val _allotments = MutableStateFlow<List<AgencyAllotment>>(emptyList())
    val allotments: StateFlow<List<AgencyAllotment>> = _allotments.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    init {
        loadData()
    }

    fun loadData() {
        viewModelScope.launch {
            _isLoading.value = true
            _agencies.value = agencyRepository.getAgencies()
            _allotments.value = agencyRepository.getAllotments()
            _isLoading.value = false
        }
    }

    fun addAgency(name: String, contactInfo: String, commissionRate: Double?) {
        viewModelScope.launch {
            agencyRepository.createAgency(Agency(name = name, contactInfo = contactInfo, commissionRate = commissionRate))
            loadData()
        }
    }

    fun updateAgency(id: String, name: String, contactInfo: String, commissionRate: Double?) {
        viewModelScope.launch {
            agencyRepository.updateAgency(Agency(id = id, name = name, contactInfo = contactInfo, commissionRate = commissionRate))
            loadData()
        }
    }

    fun deleteAgency(id: String) {
        viewModelScope.launch {
            agencyRepository.deleteAgency(id)
            loadData()
        }
    }

    fun addAllotment(agencyId: String, startDate: String, endDate: String, allottedRooms: Int) {
        viewModelScope.launch {
            agencyRepository.createAllotment(
                AgencyAllotment(
                    agencyId = agencyId,
                    startDate = startDate,
                    endDate = endDate,
                    allottedRooms = allottedRooms
                )
            )
            loadData()
        }
    }

    fun deleteAllotment(id: String) {
        viewModelScope.launch {
            agencyRepository.deleteAllotment(id)
            loadData()
        }
    }
}
